import React from 'react';
import { StarIcon, UsersIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustBadges } from './TrustBadges';
import { CHECKOUT_URLS } from '../data/checkout';
const PACK_IMAGE = 'https://cdn.magicpatterns.com/uploads/wQBu42XxddoDNWoxaZqHa4/ChatGPT_Image_13_ago_2026,_08_37_43_p.m..png';
export function Hero() {
  return <header className="w-full bg-cream" data-id="element-118" data-mp="4jvyzk2o7p0h">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 pb-14 pt-10 sm:px-8 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,1fr)] lg:items-center lg:gap-12 lg:pb-16 lg:pt-14" data-id="element-119" data-mp="128fqzmni4jxa">
        <div data-id="element-120" data-mp="sb1a5lxo1t4g">
          <p className="inline-flex items-center gap-2 rounded-full border border-sage/40 bg-sage-soft px-4 py-1.5 text-xs font-bold uppercase tracking-[0.14em] text-sage-deep" data-id="element-121" data-mp="sarsqmqosuad">
            <span aria-hidden="true" data-id="element-122" data-mp="3d1ii934hv0k9">🇦🇷</span>
            El sistema de cocina N°1 para diabéticos en Argentina
          </p>

          <h1 className="mt-6 font-display text-4xl font-extrabold leading-[1.06] tracking-tight text-petrol sm:text-5xl lg:text-[3.4rem]" data-id="element-123" data-mp="3825wymt9u1js">
            Te dijeron que tenías diabetes.{' '}
            <span className="text-cta-hover" data-id="element-124" data-mp="3o858h3cjnn0v">
              Nadie te dijo que ibas a tener que renunciar al asado para siempre.
            </span>
          </h1>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-body sm:text-xl" data-id="element-125" data-mp="39cpcgsselh1u">
            Hay una forma de seguir comiendo lo que te gusta — adaptado, sin picos de glucosa, con
            ingredientes que comprás en cualquier super argentino. Y está toda en un solo lugar.
          </p>

          <p className="mt-5 max-w-xl border-l-4 border-sage pl-4 text-base leading-relaxed text-body" data-id="element-126" data-mp="35au9zkyqkxmh">
            <strong className="font-semibold text-petrol" data-id="element-127" data-mp="2qi0mpdd83d79">
              300+ recetas · 6 Tomos · Menús semanales · Listas de compras.
            </strong>{' '}
            Todo listo para usar. Sin buscar. Sin improvisar. Sin renunciar al sabor.
          </p>

          <div className="mt-8" data-id="element-128" data-mp="2ljgzzaqt1xdu">
            <CtaButton href={CHECKOUT_URLS.megapack} data-id="element-129" data-mp="2lmla0oqybncf">Quiero recuperar mi cocina ahora</CtaButton>
          </div>

          <TrustBadges className="mt-6" data-id="element-130" data-mp="nbbev44vul7x" />
        </div>

        <div data-id="element-131" data-mp="n9qira2x6u7y">
          <img src={PACK_IMAGE} alt="MegaPack Cocina Para Diabéticos: 6 tomos, planificador de menús semanal, lista de compras y guías bonus" className="mx-auto w-full max-w-xl drop-shadow-2xl" width={1280} height={1280} data-id="element-132" data-mp="na06er0hspah" />
        </div>
      </div>

      <div className="border-y border-beige-deep bg-beige" data-id="element-133" data-mp="1ayjhfeaxfg69">
        <ul className="mx-auto flex max-w-6xl flex-col items-center gap-3 px-5 py-4 text-sm font-semibold text-body sm:flex-row sm:justify-center sm:gap-10 sm:px-8" data-id="element-134" data-mp="16342sk53hg8s">
          <li className="flex items-center gap-2" data-id="element-135" data-mp="x1nvwmdhnw9b">
            <UsersIcon className="h-4 w-4 text-sage-deep" aria-hidden="true" data-id="element-136" data-mp="x37bsbv8g5ak" />
            +1.200 personas con diabetes y sus familias ya lo tienen
          </li>
          <li className="flex items-center gap-2" data-id="element-137" data-mp="3hqaian1817jz">
            <StarIcon className="h-4 w-4 fill-cta text-cta" aria-hidden="true" data-id="element-138" data-mp="3htpzbveggqo1" />
            4.9 / 5 de valoración
          </li>
          <li className="flex items-center gap-2" data-id="element-139" data-mp="21aejxk2ygrc7">
            <ShieldCheckIcon className="h-4 w-4 text-sage-deep" aria-hidden="true" data-id="element-140" data-mp="21b66y6ihlgqv" />
            Garantía 7 días
          </li>
        </ul>
      </div>
    </header>;
}